import { render, staticRenderFns } from "./face-vehicle.vue?vue&type=template&id=55debee4&"
import script from "./face-vehicle.vue?vue&type=script&lang=ts&"
export * from "./face-vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./face-vehicle.vue?vue&type=style&index=0&id=55debee4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports